import React from 'react';
import './MembershipForm.css';
import Footer from '../Footer';

const MembershipForm = () => {
  return (
    <div
      style={{
        
        flexDirection: 'column',
        minHeight: '100vh', // Ensures the container spans the full viewport height
      }}
    >
      {/* Main content */}
      <div className="membership-form-container" style={{ flex: 1 }}>
        <h2>Become a Member</h2>
        <p>Fill out the form below to join our membership program.</p>
        <div className="form-iframe">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLScRvOvLSGqlS-xpLDM4KfxmRidG2wTzYEdv2iYcnSEO8GngbQ/viewform?embedded=true"
            width="100%"
            height="600px"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Membership Form"
            allowFullScreen
          >
            Loading…
          </iframe>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MembershipForm;
